import React, { useMemo } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './OrangeExplosion.css';

const OrangeExplosion = ({ isActive, onComplete }) => {
  // Generate stable random splash positions (memoized to prevent re-renders)
  const splashes = useMemo(() =>
    Array.from({ length: 12 }, (_, i) => ({
      id: i,
      x: 10 + (i % 4) * 25 + Math.random() * 15,
      y: 10 + Math.floor(i / 4) * 30 + Math.random() * 15,
      size: 100 + Math.random() * 120,
      delay: i * 0.05,
      rotation: Math.random() * 360,
    })), []);

  return (
    <AnimatePresence>
      {isActive && (
        <motion.div
          className="orange-explosion-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeOut" }}
          onAnimationComplete={() => {
            setTimeout(onComplete, 1800);
          }}
        >
          {/* Central burst - appears first */}
          <motion.div
            className="central-burst"
            initial={{ scale: 0, opacity: 0 }}
            animate={{
              scale: [0, 2.5, 2],
              opacity: [0, 0.9, 0.7],
            }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          />

          {/* Splashes radiate outward */}
          {splashes.map((splash) => (
            <motion.div
              key={splash.id}
              className="orange-splash"
              style={{
                left: `${splash.x}%`,
                top: `${splash.y}%`,
                width: splash.size,
                height: splash.size,
              }}
              initial={{ scale: 0, opacity: 0 }}
              animate={{
                scale: [0, 1.2, 1],
                opacity: [0, 0.8, 0.6],
              }}
              transition={{
                duration: 0.6,
                delay: splash.delay,
                ease: "easeOut",
              }}
            />
          ))}

          {/* Go Orange text */}
          <motion.div
            className="go-orange-text"
            initial={{ scale: 0.5, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.5, ease: "easeOut" }}
          >
            GO ORANGE!
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default OrangeExplosion;
